module.exports = __webpack_public_path__ + "media/sub7-6-1.06cbfaf7.mp4";